import request from '@/router/axios'

const baseUrl = '/api/produce/out-in-stock-record/inventory-warning'

export const fetchSummary = data => {
  return request({
    url: `${baseUrl}/summary`,
    method: 'post',
    data
  })
}

export const fetchPage = data => {
  return request({
    url: `${baseUrl}/page`,
    method: 'post',
    data
  })
}

export const fetchCustomerOptions = params => {
  return request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'get',
    params
  })
}

export const fetchCargoOptions = params => {
  return request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params
  })
}
